<div
	@fadeInOut
	class="fixed inset-0 z-50 flex items-center justify-center bg-peps-dark-900/50"
	(click)="onBackgroundClick($event)"
>
	<div
		@scaleInOut
		class="h-full w-full bg-peps-dark-700 relative p-8 md:h-fit xl:w-10/12 overflow-y-scroll custom-vertical-scrollbar"
	>
		<div class="flex flex-row items-center gap-2 w-fit">
			<img src="assets/images/team_peps_logo.avif" alt="Team Peps" class="h-10" />
			<span class="uppercase text-2xl">{{ 'component.place-challenge.title' | translate }}</span>
		</div>
		<button
			class="absolute top-4 right-4 text-peps-dark-200 hover:text-white transition cursor-pointer"
			(click)="closeChallengeModal()">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-10">
				<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
			</svg>
		</button>

		<div class="grid grid-cols-1 xl:grid-cols-2 gap-4 my-4 py-2 px-6 max-h-full md:max-h-[450px] overflow-y-scroll custom-vertical-scrollbar">
			@for(challenge of challenges(); track challenge.id) {
				<peps-challenge-card
					[challenge]="challenge"
					[isUserHasCompleted]="isChallengeCompleted(challenge)"
				></peps-challenge-card>
			}
		</div>
	</div>
</div>
